'use strict';
const React = require('react');
const BaseComponent = require('../../shared/base');
let client = require('../../../../sdk/client');
const Currency = require('currency-symbol-map');

class ItemsPartesComponent extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            arrRelationalParts: [],
            strCookieAddressId:""
        }

        this.defaultImage = "/assets/images/bepensa/cumminsNoImage.jpg";
        this.arrOfParts = [];
        this.boolNowHasItems = false;
        this.boolHasBeenLoaded = false;
        this.index = 0;
    }

    itemUrl(itemName, itemId) {
        return "/items/" + this.generateSlug(itemName) + "/" + itemId;
    }

    subFormatMoney(
        numAmount_I,
        intDecimalCount = 2,
        strDecimal = ".",
        strThousands = ","
    ) {
        try {
            intDecimalCount = Math.abs(intDecimalCount);
            intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

            const negativeSign = numAmount_I < 0 ? "-" : "";

            let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
            let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

            return negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
                str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
                    strThousands) + (intDecimalCount ? strDecimal +
                        Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
        } catch (e) {
            //console.log(e)
        }
    }

    subToMXNCurrency(
        strPrice_I
    )
    {
        let currencyPrice = strPrice_I;
        try {
            //#exchange-currency is got from exchange-currency header.
            currencyPrice = parseFloat(strPrice_I) * $("#exchange-currency").attr("currency");
        } catch (error) {}

        return currencyPrice;
    }

    loadSalePrices() {
        //                                                  //This id is taken from the widget.
        var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");
        
        if (this.props.user.Guest == false && (depotId != null && depotId != "")) {
            var self = this;
            let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
            let externalUserId =
                this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
            //To test: 
            //let externalUserId = {Values:["215"]};

            const priceParams = {
                deptoId: depotId,
                //MXN currency by default
                currencyCode: "MXN",
                customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "PROGRAMADO",
                detail: this.arrOfParts
            };

            client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                if (
                    response.Result != undefined && response.Result == 0 &&
                    response.PartsCode != undefined && response.PartsCode.length > 0
                ) {
                    response.PartsCode.forEach(function (part, index) {
                        var partNumber = part.PartCode;
                        var salePrice = null;
                        var corePrice = null;
                        if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                            document.getElementById('precioPublico' + partNumber).innerHTML = `<b>$ ${self.subFormatMoney(part.PartsPrices[0].PublicPrice)} MXN</b>`;
                            
                            if(userType != 'B2C') {
                                if(part.PartsPrices[0].PublicPrice != part.PartsPrices[0].SalePrice) {
                                    document.getElementById('precioPublico' + partNumber).setAttribute('style', 'text-decoration: line-through;color: red !important;');
                                    document.getElementById('precioDescuento' + partNumber).innerHTML = ` <b>$ ${self.subFormatMoney(part.PartsPrices[0].SalePrice)} MXN</b>`;
                                }
                            }
                            
                            salePrice = part.PartsPrices[0].SalePrice;
                            if (part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null) {
                                corePrice = part.PartsPrices[0].CorePart.SalePrice
                            }

                            //If match with any item in state.arrOffers update his value
                            let indexOf = -1;
                            self.state.arrRelationalParts.forEach((item, index) => {
                                if (item.strNumberPart == partNumber) {
                                    indexOf = index;
                                }
                            });
                            if (indexOf >= 0) {
                                self.state.arrRelationalParts[indexOf].boolIsOverridenPrice = salePrice != null ? true : false;
                                self.state.arrRelationalParts[indexOf].boolIsOverridenCore = corePrice != null ? true : false;
                                self.state.arrRelationalParts[indexOf].SalePrice = salePrice || "";
                                self.state.arrRelationalParts[indexOf].SaleCorePrice = corePrice || "";
                            }
                        }
                    });
                    self.forceUpdate();
                }
            });
        }else {
            //                                              //If not loaded yet billing-address-lider try again on the
            //                                              //      next second.
            setTimeout(() => {
                this.loadSalePrices();
            }, 1000);
        }
    }

    renderRelationalParts(
        boolRenderSalePrices_I = true
    ) {
        var self = this;
        var items = [];
        if (!this.boolNowHasItems) {
            this.boolNowHasItems = true;
            this.props.items.forEach((item) => {
                //console.log(response)
                var itemCF = null;
                var strNumberPart = "";
                if (item.CustomFields != null) {
                    itemCF = item.CustomFields.find(cf => cf.Name == "Número de Parte");
                }
                if (itemCF != null && itemCF.Values[0] != "") {
                    strNumberPart = itemCF.Values[0];
                    self.arrOfParts.push({ "partCode": strNumberPart });
                }
                item['boolIsOverridenPrice'] = false;
                item['boolIsOverridenCore'] = false;
                item['strNumberPart'] = strNumberPart;
                item['SalePrice'] = "";
                item['SaleCorePrice'] = "";

                items.push(item);
            });

            this.setState({
                arrRelationalParts: items
            }, () => {
                self.initCarousel();
            });

            if (boolRenderSalePrices_I) {
                this.loadSalePrices();
            }
        }
    }

    initCarousel() {
        $('.relation-parts-items').slick({
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 770,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }

    componentDidMount() {
        //                                                  //Try to render MXN prices once the exchange currency has
        //                                                  //      been got.
        this.subRefreshCurrency();

        //var script = document.createElement('script');
        //script.src = "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdy4m7CGEZn2J_2BQglMsCpraSZhwiVra2PG8m2sT6GvLl3.js";
        //document.getElementById("smcx-sdk").appendChild(script);
    }

    subRefreshCurrency()
    {
        let currency = $("#exchange-currency").attr("currency");
        if(currency != null && currency != "-"){
            this.forceUpdate();
        }else{
            setTimeout(() => {
                this.subRefreshCurrency();
            }, 500);
        }
    }

    componentDidUpdate() {
        //Una vez que this.props.items se actualiza gracias a que se le suministra una coleccion nueva de items gracias al state
        //del caller del compoenente padre comprobamos si tiene items y tratamos de renderizar los precios cliente
        //TODO: comprobar si this.props.user.CustomFields tiene el CF de Client ID, si no, cargar aqui el usuario (getUSerDetails)
        //para obtener, actualizar o simplemente obtener el CF Client ID para renderizar los precios cliente.
        //En este punto del desarrollo se asume que item-info suministra el CF citado, pero, si se usara este componente fuera de
        //este flujo entonces seria necesario lo que describi. MJAC.  
        if (this.props.items.length > 0 && !this.boolHasBeenLoaded) {
            this.boolHasBeenLoaded = true;
            this.subTryToLoadCarrousel(true);
        }
    }

    subTryToLoadCarrousel(
        boolLoadPrices_I
    )
    {
        if (
            !this.boolAddressStuffWasLoaded() || this.boolAddressStuffWasLoaded()
            )
        {
            this.renderRelationalParts(boolLoadPrices_I);
            this.addressChanged();
        }
        else 
        {
            setTimeout( () => {
                this.subTryToLoadCarrousel();
            }, 1000)
        }
    }

    boolAddressStuffWasLoaded(){
        let boolAddressStuffWasLoaded = false;
        var addressId = document.getElementById("address-name").getAttribute("addressid");
        var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");
        if (
            addressId != null && addressId != "" && depotId != null && depotId != ""
            )
        {
            this.setState({strCookieAddressId:addressId});
            boolAddressStuffWasLoaded = true;
        }

        return boolAddressStuffWasLoaded;
    }

    addressChanged(){
        //var addressId = this.getCookie('SelectedAddress');
        var addressId = $('#address-name').attr('addressid');
        //console.log("recursive addressId: " + addressId);
        if(addressId != this.state.strCookieAddressId){
            let self = this;
            this.setState({strCookieAddressId:addressId}, () => {
                self.loadSalePrices();
                self.addressChanged();
            });        
        }
        else{
            //Recursive method called every 1 second
            setTimeout(() => {
                this.addressChanged();
            }, 1000 )
        }
    }

    renderOffer(item, classPrecioCore){
        //TODO: Change hardcoded Category for reusability	
        if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore == 'hide')
        {
            return (
                <div id="container-info-offerts-carousel">
                    <div id="icon-offers">
                     	<div id="star-offers-carousel">&#10040;</div>
                        <div id="character-offers-carousel">%</div>
                    </div>
                    <div id = "offers-text-carousel">Oferta</div>
			    </div>
            ); 
 	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) != undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div className="store-rating item-footer-images-container">
                    <div>
                    	<div id="container-info-offerts-carousel">
                       		<div id="icon-offers">
                        	    <div id="star-offers-carousel">&#10040;</div>
                            	<div id="character-offers-carousel">%</div>
                        	</div>
                        	<div id = "offers-text-carousel">Oferta</div>
		                    <div id="icon-recon-carousel">
                            	<div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        	</div>
                        	<div id = "recon-text-carousel">Recon</div>
                    	</div>
                	</div>
                </div>
            );
	    } 
        else if(item.Categories.find(x => x.ID == process.env.OFFERS) == undefined && classPrecioCore != 'hide') 
        {
	        return (
                <div style={{ width: '100%', "textAlign": 'right' }}>
                    <div id="container-info-offerts-carousel-nooffer">
                        <div id="icon-recon-carousel">
                            <div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        </div>
                        <div id = "recon-text-carousel">Recon</div>
	                </div>
                </div>
	        );
	    }
    }

    addItemToCart(e) {
        const { CurrencyCode, Media, Name, Price } = e;
        const self = this;

        var strCurrencyCode = "";
        var currencyCodeCf = e.CustomFields.find(x => x.Name == "Currency");   
        if (currencyCodeCf != undefined || currencyCodeCf != null) {
            if(currencyCodeCf.Values[0].length > 0){
                strCurrencyCode = currencyCodeCf.Values[0];
            }                       
        }
        var priceItem = e.Price;
        if(process.env.BASE_URL == "bepensab2c.staging.arcadier.io"){
            if(self.state != null && self.state.currentExchange != null && self.state.currentExchange != "-"){
                    
                let strMXNPrice = e.Price;
                    
                if(strCurrencyCode != "MXN"){
                    strMXNPrice = e.Price * self.state.currentExchange;
                }                        
                priceItem = strMXNPrice;
            }
        }

        let partNumberCf;
        try {
            partNumberCf = e.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);
        } catch (error) {
            console.error(".Find error:", error);
        }
        let partNumber = "";

        if (partNumberCf != undefined) {
            partNumber = partNumberCf.Values[0];
        }

        var userIsB2C = true;
        try {
            if(self.props.user.Guest) {
                userIsB2C = true;
            } else {
                if(self.props.user.CustomFields) {
                    try {
                        userIsB2C = self.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                    } catch (error) {
                        console.error(".Find error:", error);
                    }
                }
            }
        } catch(error) {
        }

        try {
            var avalExis = 0;
            if(typeof window !== 'undefined'){
                avalExis = parseInt(document.getElementById("existenciasSearch" + partNumber).innerText);
            }
            if(avalExis > 0 ) {
                let item = e;
                var errPrompt = [];
                try {
                    if (self.props.processing === true) {
                        return;
                    }
                } catch(error) {
                }

                $('.minimum-order-not-met-error-container').hide();
                $('.not-enough-stock-error-container').hide();
                $('.required').removeClass('error-con');
                try {
                    if (self.props.user.Guest && self.props.controlFlags.GuestCheckoutEnabled === false) {
                        toastr.error('Feature not available yet for guest user.')
                        return;
                    }
                } catch(error) {
                }

                let hasEmpty = false;
                var userId;
                var numQty = e.CustomFields.find(x => x.Code == process.env.CF_SALES_UNIT);

                var priceValues = {
                    quantity: numQty.Values[0]
                };

                let guestUserID = "";
                if (!self.props.user) {
                    if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                        guestUserID = CommonModule.getCookie("guestUserID");
                    }
                } else {
                    guestUserID = self.props.user.ID;
                }

                console.log("guestUserID " + guestUserID);
                    //console.log("userId " + userId);

                const options = {
                    pageSize: 100,
                    pageNumber: 1,
                    includes: null,
                    guestUserID: guestUserID
                };

                let APIurl = "/cart/getUserCarts?pageSize=" + options.pageSize + "&pageNumber=" + options.pageNumber + "&includes=" + options.includes + "&guestUserID=" + options.guestUserID;

                var settings = {
                    "url": APIurl,
                    "method": "GET",
                    "timeout": 0,
                };

                $.ajax(settings).done(function (response) {
                    let cartList = [];
                    let cartCount = 0;
                    if (response.TotalRecords > 0 && response.Records) {
                        cartList = response.Records;
                        cartList.map(cart => cartCount += parseInt(cart.Quantity || 0));
                    }

                    cartList.map(function (cart) {
                        //ARC10053 the discountamount should not be round off to have the correct value.
                        if (cart.DiscountAmount) {
                            cart.DiscountAmount = parseFloat(cart.DiscountAmountNotRoundOff) || 0;
                        }
                    });

                    let quantityToPass = priceValues.quantity;
                    let cartItemId = null;

                    const itemExistsInCartLocal = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                    if (process.env.PRICING_TYPE != 'service_level') {
                        const itemExistsInCart = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                        cartItemId = itemExistsInCart ? itemExistsInCart.ID : null;
                        if (itemExistsInCart) {
                            quantityToPass = parseInt(priceValues.quantity) + parseInt(itemExistsInCart.Quantity);
                        }
                    }
                    if(itemExistsInCartLocal){
                        var itemQty = itemExistsInCartLocal.Quantity;
                        var qtyFinal = itemQty;
                        if ((qtyFinal + priceValues.quantity) > parseInt(priceValues.quantity) && self.isThisUserB2C === true) {
                            toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                            //self.props.setProcessing(false);
                            return;
                        } else {
                            const options = {
                                selectedQuantity: priceValues.quantity,
                                discount: priceValues.discount,
                                itemId: e.ID,
                                force: true,
                                isComparisonOnly: false,
                                ServiceBookingUnitGuid: null,
                                bookingSlot: null
                            };

                            window.gtag("event", "add_to_cart", {
                                'app_name': 'Megamak',
                                'item_added': 'Item: ' + e.BuyerDescription
                            });

                            const { CurrencyCode, Media, Name } = e;
                            const itemId = options.itemId;
                            const selectedQuantity = options.selectedQuantity || 0;
                            const discount = options.discount || 0;
                            const force = options.force;
                            const isComparisonOnly = options.isComparisonOnly;
                            const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                            const bookingSlot = options.bookingSlot;
                            const addOns = options.addOns;

                            $.ajax({
                                url: '/items/getItemDetails',
                                type: 'GET',
                                data: {
                                    itemId: e.ID
                                },
                                success: function (result) {
                                    e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                    e.IsAvailable = result.IsAvailable;
                                    e.Active = result.Active;

                                    if (e.Active) {
                                        let url = '/items/addCart';
                                        let method = 'POST';

                                        if (cartItemId) {
                                            url = '/items/editCart';
                                            method = 'PUT';
                                        }
                                        let guestUserID = "";
                                        if (!self.props.user) {
                                            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                                guestUserID = CommonModule.getCookie("guestUserID");
                                            }
                                        } else {
                                            guestUserID = self.props.user.ID;
                                        }

                                        //fix
                                        var quantity = 1;
                                        $.ajax({
                                            url: url,
                                            type: method,
                                            data: {
                                                cartItemId: cartItemId,
                                                quantity: quantity,
                                                discount: discount,
                                                itemId: itemId,
                                                force: force,
                                                forComparison: isComparisonOnly,
                                                guestUserID: guestUserID,                            
                                                serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                addOns: addOns ? JSON.stringify(addOns) : null,
                                            },
                                            success: function (result) {
                                                if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                    if (result.Code == 'INSUFFICIENT_STOCK') {
                                                        if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                        }
                                                    } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                        if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                        }
                                                    }
                                                return dispatch({
                                                        type: '',
                                                    });
                                                }
                                                if (result.AccessToken && result.AccessToken.UserId) {
                                                CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                }
                                                if (e.HasChildItems && e.ChildItems) {
                                                    e.ChildItems.forEach(function (child) {
                                                        if (child.ID === itemId) {
                                                            if (child.StockLimited === true && !isComparisonOnly) {
                                                                //ARC9590
                                                                child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    if (!isComparisonOnly) {
                                                        e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                    }
                                                }

                                                if (typeof successCallback === 'function') {
                                                    successCallback(result);
                                                }

                                                //toastr.success("Artículo agregado al carrito.");
                                                if(typeof window !== 'undefined') {
                                                    document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                }
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            },
                                            error: function (jqXHR, textStatus, errorThrown) {
                                                console.log(textStatus, errorThrown);
                                            }
                                        });
                                    } else {
                                        if (typeof failedCallback === 'function') {
                                            let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                            if (isComparisonOnly) {
                                                errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                            }
                                            failedCallback(errObj);
                                        }

                                        return dispatch({
                                            type: actionTypes.ADD_EDIT_CART,
                                            items: Object.assign({}, e)
                                        });
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log(textStatus, errorThrown);
                                }
                            });
                        }
                    } else {
                        const options = {
                            selectedQuantity: priceValues.quantity,
                            discount: priceValues.discount,
                            itemId: e.ID,
                            force: true,
                            isComparisonOnly: false,
                            ServiceBookingUnitGuid: null,
                            bookingSlot: null
                        };

                        window.gtag("event", "add_to_cart", {
                            'app_name': 'Megamak',
                            'item_added': 'Item: ' + e.BuyerDescription
                        })

                        const itemId = options.itemId;
                        const selectedQuantity = options.selectedQuantity || 0;
                        const discount = options.discount || 0;
                        const force = options.force;
                        const isComparisonOnly = options.isComparisonOnly;
                        const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                        const bookingSlot = options.bookingSlot;
                        const addOns = options.addOns;

                        $.ajax({
                            url: '/items/getItemDetails',
                            type: 'GET',
                            data: {
                                itemId: e.ID
                            },
                            success: function (result) {
                                e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                e.IsAvailable = result.IsAvailable;
                                e.Active = result.Active;

                                if (e.Active) {
                                    let url = '/items/addCart';
                                    let method = 'POST';

                                    if (cartItemId) {
                                        url = '/items/editCart';
                                        method = 'PUT';
                                    }
                                    let guestUserID = "";
                                    if (!self.props.user) {
                                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                            guestUserID = CommonModule.getCookie("guestUserID");
                                        }
                                    } else {
                                        guestUserID = self.props.user.ID;
                                    }

                                    //Fix
                                    var quantity = 1;
                                    $.ajax({
                                        url: url,
                                        type: method,
                                        data: {
                                            cartItemId: cartItemId,
                                            quantity: quantity,
                                            discount: discount,
                                            itemId: itemId,
                                            force: force,
                                            forComparison: isComparisonOnly,
                                            guestUserID: guestUserID,                            
                                            serviceBookingUnitGuid: serviceBookingUnitGuid,
                                            bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                            addOns: addOns ? JSON.stringify(addOns) : null,
                                        },
                                        success: function (result) {
                                            if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                if (result.Code == 'INSUFFICIENT_STOCK') {
                                                    if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                    }
                                                } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                    if (typeof failedCallback === 'function') {
                                                    failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                    }
                                                }
                                            return dispatch({
                                                    type: '',
                                                });
                                            }
                                            if (result.AccessToken && result.AccessToken.UserId) {
                                            CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                            }
                                            if (e.HasChildItems && e.ChildItems) {
                                                e.ChildItems.forEach(function (child) {
                                                    if (child.ID === itemId) {
                                                        if (child.StockLimited === true && !isComparisonOnly) {
                                                            //ARC9590
                                                            child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                        }
                                                    }
                                                });
                                            } else {
                                                if (!isComparisonOnly) {
                                                    e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                }
                                            }

                                            if (typeof successCallback === 'function') {
                                                successCallback(result);
                                            }

                                            if(typeof window !== 'undefined') {
                                                //toastr.success("Artículo agregado al carrito.");
                                                document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            } else {
                                                $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                
                                                setTimeout(function () {
                                                    var target = $(".h-cart .h-dd-menu.add-cart");
                                                    target.removeClass('fadeout');
                                                }, 3000);
                                            }
                                        },
                                        error: function (jqXHR, textStatus, errorThrown) {
                                            console.log(textStatus, errorThrown);
                                            toastr.error("No se pudo agregar al carrito.");
                                        }
                                    });
                                } else {
                                    toastr.error("No se pudo agregar al carrito.");
                                    if (typeof failedCallback === 'function') {
                                        let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                        if (isComparisonOnly) {
                                            errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                        }
                                        failedCallback(errObj);
                                    }

                                    return dispatch({
                                        type: actionTypes.ADD_EDIT_CART,
                                        items: Object.assign({}, e)
                                    });
                                }
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log(textStatus, errorThrown);
                            }
                        });
                    }
                });
            } else {
                userIsB2C = window.REDUX_DATA.userReducer.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];

                if(userIsB2C == "B2B") {
                    try {
                        if (self.props.processing === true) {
                            return;
                        }
                    } catch(error) {
                    }

                    $('.minimum-order-not-met-error-container').hide();
                    $('.not-enough-stock-error-container').hide();
                    $('.required').removeClass('error-con');
                    try {
                        if (self.props.user.Guest && self.props.controlFlags.GuestCheckoutEnabled === false) {
                            toastr.error('Feature not available yet for guest user.')
                            return;
                        }
                    } catch(error) {
                    }

                    var numQty = e.CustomFields.find(x => x.Code == process.env.CF_SALES_UNIT);

                    var priceValues = {
                        quantity: numQty.Values[0]
                    };

                    let guestUserID = "";
                    //if (!self.props.user) {
                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                            guestUserID = CommonModule.getCookie("guestUserID");
                        }
                    ///} else {
                    ///    userId = self.props.user.ID;
                    //}

                    console.log("guestUserID " + guestUserID);
                        //console.log("userId " + userId);

                    const options = {
                            pageSize: 1000,
                            pageNumber: 1,
                            includes: null,
                            guestUserID: guestUserID
                        };

                    let APIurl = "/cart/getUserCarts?pageSize=" + options.pageSize + "&pageNumber=" + options.pageNumber + "&includes=" + options.includes + "&guestUserID=" + options.guestUserID;

                    var settings = {
                        "url": APIurl,
                        "method": "GET",
                        "timeout": 0,
                    };

                    $.ajax(settings).done(function (response) {
                        let cartList = [];
                        let cartCount = 0;
                        if (response.TotalRecords > 0 && response.Records) {
                            cartList = response.Records;
                            cartList.map(cart => cartCount += parseInt(cart.Quantity || 0));
                        }

                        cartList.map(function (cart) {
                            //ARC10053 the discountamount should not be round off to have the correct value.
                            if (cart.DiscountAmount) {
                                cart.DiscountAmount = parseFloat(cart.DiscountAmountNotRoundOff) || 0;
                            }
                        });

                        let quantityToPass = priceValues.quantity;
                        let cartItemId = null;
                        const itemExistsInCartLocal = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                        if (process.env.PRICING_TYPE != 'service_level') {
                            const itemExistsInCart = cartList.find(cl => cl.ItemDetail.ID == e.ID);
                            cartItemId = itemExistsInCart ? itemExistsInCart.ID : null;
                            if (itemExistsInCart) {
                                quantityToPass = parseInt(priceValues.quantity) + parseInt(itemExistsInCart.Quantity);
                            }
                        }
                        if(itemExistsInCartLocal){
                            var itemQty = itemExistsInCartLocal.Quantity;
                            var qtyFinal = itemQty;
                            if ((qtyFinal + priceValues.quantity) > parseInt(priceValues.quantity) && self.isThisUserB2C === true) {
                                toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                                //self.props.setProcessing(false);
                                return;
                            } else {
                                const options = {
                                    selectedQuantity: priceValues.quantity,
                                    discount: priceValues.discount,
                                    itemId: e.ID,
                                    force: true,
                                    isComparisonOnly: false,
                                    ServiceBookingUnitGuid: null,
                                    bookingSlot: null
                                };

                                window.gtag("event", "add_to_cart", {
                                    'app_name': 'Megamak',
                                    'item_added': 'Item: ' + e.BuyerDescription
                                });

                                const itemId = options.itemId;
                                const selectedQuantity = options.selectedQuantity || 0;
                                const discount = options.discount || 0;
                                const force = options.force;
                                const isComparisonOnly = options.isComparisonOnly;
                                const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                                const bookingSlot = options.bookingSlot;
                                const addOns = options.addOns;

                                $.ajax({
                                    url: '/items/getItemDetails',
                                    type: 'GET',
                                    data: {
                                        itemId: e.ID
                                    },
                                    success: function (result) {
                                        e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                        e.IsAvailable = result.IsAvailable;
                                        e.Active = result.Active;

                                        if (e.Active) {
                                            let url = '/items/addCart';
                                            let method = 'POST';

                                            if (cartItemId) {
                                                url = '/items/editCart';
                                                method = 'PUT';
                                            }
                                            let guestUserID = "";
                                            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                                guestUserID = CommonModule.getCookie("guestUserID");
                                            }

                                            //fix
                                            var quantity = 1;
                                            $.ajax({
                                                url: url,
                                                type: method,
                                                data: {
                                                    cartItemId: cartItemId,
                                                    quantity: quantity,
                                                    discount: discount,
                                                    itemId: itemId,
                                                    force: force,
                                                    forComparison: isComparisonOnly,
                                                    guestUserID: guestUserID,                            
                                                    serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                    bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                    addOns: addOns ? JSON.stringify(addOns) : null,
                                                },
                                                success: function (result) {
                                                    if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                        if (result.Code == 'INSUFFICIENT_STOCK') {
                                                            if (typeof failedCallback === 'function') {
                                                                failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                            }
                                                        } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                            if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                            }
                                                        }
                                                    return dispatch({
                                                            type: '',
                                                        });
                                                    }
                                                    if (result.AccessToken && result.AccessToken.UserId) {
                                                    CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                    }
                                                    if (e.HasChildItems && e.ChildItems) {
                                                        e.ChildItems.forEach(function (child) {
                                                            if (child.ID === itemId) {
                                                                if (child.StockLimited === true && !isComparisonOnly) {
                                                                    //ARC9590
                                                                    child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                                }
                                                            }
                                                        });
                                                    } else {
                                                        if (!isComparisonOnly) {
                                                            e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                        }
                                                    }

                                                    if (typeof successCallback === 'function') {
                                                        successCallback(result);
                                                    }

                                                    if(typeof window !== 'undefined') {
                                                        //toastr.success("Artículo agregado al carrito.");
                                                        document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                        $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                        priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                        
                                                        setTimeout(function () {
                                                            var target = $(".h-cart .h-dd-menu.add-cart");
                                                            target.removeClass('fadeout');
                                                        }, 3000);
                                                    } else {
                                                        $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                        priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                        setTimeout(function () {
                                                            var target = $(".h-cart .h-dd-menu.add-cart");
                                                            target.removeClass('fadeout');
                                                        }, 3000);
                                                    }
                                                },
                                                error: function (jqXHR, textStatus, errorThrown) {
                                                    console.log(textStatus, errorThrown);
                                                }
                                            });
                                        } else {
                                            if (typeof failedCallback === 'function') {
                                                let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                                if (isComparisonOnly) {
                                                    errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                                }
                                                failedCallback(errObj);
                                            }

                                            return dispatch({
                                                type: actionTypes.ADD_EDIT_CART,
                                                items: Object.assign({}, e)
                                            });
                                        }
                                    },
                                    error: function (jqXHR, textStatus, errorThrown) {
                                        console.log(textStatus, errorThrown);
                                    }
                                });
                            }
                        } else {
                            const options = {
                                selectedQuantity: priceValues.quantity,
                                discount: priceValues.discount,
                                itemId: e.ID,
                                force: true,
                                isComparisonOnly: false,
                                ServiceBookingUnitGuid: null,
                                bookingSlot: null
                            };

                            window.gtag("event", "add_to_cart", {
                                'app_name': 'Megamak',
                                'item_added': 'Item: ' + e.BuyerDescription
                            })

                            const itemId = options.itemId;
                            const selectedQuantity = options.selectedQuantity || 0;
                            const discount = options.discount || 0;
                            const force = options.force;
                            const isComparisonOnly = options.isComparisonOnly;
                            const serviceBookingUnitGuid = options.serviceBookingUnitGuid || null;
                            const bookingSlot = options.bookingSlot;
                            const addOns = options.addOns;

                            $.ajax({
                                url: '/items/getItemDetails',
                                type: 'GET',
                                data: {
                                    itemId: e.ID
                                },
                                success: function (result) {
                                    e.IsVisibleToCustomer = result.IsVisibleToCustomer;
                                    e.IsAvailable = result.IsAvailable;
                                    e.Active = result.Active;

                                    if (e.Active) {
                                        let url = '/items/addCart';
                                        let method = 'POST';

                                        if (cartItemId) {
                                            url = '/items/editCart';
                                            method = 'PUT';
                                        }
                                        let guestUserID = "";
                                        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                                            guestUserID = CommonModule.getCookie("guestUserID");
                                        }

                                        //Fix
                                        var quantity = 1;
                                        $.ajax({
                                            url: url,
                                            type: method,
                                            data: {
                                                cartItemId: cartItemId,
                                                quantity: quantity,
                                                discount: discount,
                                                itemId: itemId,
                                                force: force,
                                                forComparison: isComparisonOnly,
                                                guestUserID: guestUserID,                            
                                                serviceBookingUnitGuid: serviceBookingUnitGuid,
                                                bookingSlot: bookingSlot ? JSON.stringify(bookingSlot) : null,
                                                addOns: addOns ? JSON.stringify(addOns) : null,
                                            },
                                            success: function (result) {
                                                if (result.ID == null && result.Code && !options.isComparisonOnly) {
                                                    if (result.Code == 'INSUFFICIENT_STOCK') {
                                                        if (typeof failedCallback === 'function') {
                                                            failedCallback(EnumCoreModule.GetToastStr().Error.INSUFFICIENT_STOCK);
                                                        }
                                                    } else if (result.Code == 'INVALID_SERVICE_BOOKING') {
                                                        if (typeof failedCallback === 'function') {
                                                        failedCallback(EnumCoreModule.GetToastStr().Error.INVALID_SERVICE_BOOKING);
                                                        }
                                                    }
                                                return dispatch({
                                                        type: '',
                                                    });
                                                }
                                                if (result.AccessToken && result.AccessToken.UserId) {
                                                CommonModule.createCookie("guestUserID", result.AccessToken.UserId, 1);
                                                }
                                                if (e.HasChildItems && e.ChildItems) {
                                                    e.ChildItems.forEach(function (child) {
                                                        if (child.ID === itemId) {
                                                            if (child.StockLimited === true && !isComparisonOnly) {
                                                                //ARC9590
                                                                child.StockQuantity = parseInt(child.StockQuantity) - parseInt(selectedQuantity);
                                                            }
                                                        }
                                                    });
                                                } else {
                                                    if (!isComparisonOnly) {
                                                        e.StockQuantity = parseInt(e.StockQuantity) - parseInt(selectedQuantity);
                                                    }
                                                }

                                                if (typeof successCallback === 'function') {
                                                    successCallback(result);
                                                }

                                                if(typeof window !== 'undefined') {
                                                    //toastr.success("Artículo agregado al carrito.");
                                                    document.getElementById('latest-cart-count').innerText = parseInt(document.getElementById('latest-cart-count').innerText) + parseInt(priceValues.quantity);
                                                    $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                    priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                    setTimeout(function () {
                                                        var target = $(".h-cart .h-dd-menu.add-cart");
                                                        target.removeClass('fadeout');
                                                    }, 3000);
                                                } else {
                                                    $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');

                                                    priceItem = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${CurrencyCode} ${Currency(CurrencyCode)}`);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceItem);
                                                    $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', Media[0].MediaUrl);

                                                    
                                                    setTimeout(function () {
                                                        var target = $(".h-cart .h-dd-menu.add-cart");
                                                        target.removeClass('fadeout');
                                                    }, 3000);
                                                }
                                            },
                                            error: function (jqXHR, textStatus, errorThrown) {
                                                console.log(textStatus, errorThrown);
                                            }
                                        });
                                    } else {
                                        if (typeof failedCallback === 'function') {
                                            let errObj = EnumCoreModule.GetToastStr().Error.ITEM_VISIBILITY_DISABLED_BY_ADMIN_OR_MERCHANT;
                                            if (isComparisonOnly) {
                                                errObj = EnumCoreModule.GetToastStr().Error.FAILED_ADD_DISABLED_ITEM_TO_COMPARISON;
                                            }
                                            failedCallback(errObj);
                                        }

                                        return dispatch({
                                            type: actionTypes.ADD_EDIT_CART,
                                            items: Object.assign({}, e)
                                        });
                                    }
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log(textStatus, errorThrown);
                                }
                            });
                        }
                    });
                } else {
                    toastr.error("El artículo no cuenta con existencias.");
                }
            }
        } catch(error) {

        }
    }

    renderCarousel() {
        console.log('render carousel');
        var self = this;
        if(this.state.arrRelationalParts.length > 12) {
	        this.state.arrRelationalParts = this.state.arrRelationalParts.slice(0, 11);
	    }

        this.state.arrRelationalParts.map(function (item, index) {
            var strPartCode = item.CustomFields.find(x => x.Code === process.env.CF_PART_NUMBER).Values[0];

            const requestBody = {
                "operatingUnitId": 446,
                "partsCode": [{
                    "partCode": strPartCode
                }]
            };

            const promiseapilider = client.Availability.GetAvalability(requestBody);
            Promise.all([promiseapilider]).then(response => {
                let avalabilityes = response[0].Parts[0].Availabilitys;
                let avalabilityesTotal = 0;
                avalabilityes.forEach(element => {
                    avalabilityesTotal = element.Availability + avalabilityesTotal;
                })

                var colorCart = 'btnaddCart btn-group btn-cart';

                if(avalabilityesTotal == 0) {     
                    colorCart += ' disabled';
                    if(typeof window !== 'undefined') {
                        if(document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                            document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                        }
                    }
                } else {
                    if(typeof window !== 'undefined') {
                        if (document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode)) {
                            document.getElementById("cartExistenciasSearch" + response[0].Parts[0].PartCode).className = colorCart;
                        }
                    }
                }

                if(typeof window !== 'undefined') {
                    if(document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode)) {
                        document.getElementById("existenciasSearch" + response[0].Parts[0].PartCode).innerText = avalabilityesTotal;
                    }
                }
            });
        });

        return (<div className="relation-parts-items">
            {this.state.arrRelationalParts.map(function (item, index) {
                self.index = self.index + 1;

                //if(self.index < self.state.arrRelationalParts.length) {
                    var itemCF = null;
                    var itemCFNP = null;
                    var itemPrice = item.Price;
                    var classCoreHide = "hide";
                    var strPrecioCore = "";
                    var strNumberPart = "";
                    var strPrecioCliente = item.SalePrice;
                    var boolIsOverridenPrice = item.boolIsOverridenPrice;
                    var boolIsOverridenCore = item.boolIsOverridenCore;
                    var strPartCode = item.CustomFields.find(x => x.Code === process.env.CF_PART_NUMBER).Values[0];

                    //css and styles to override when client price is downloaded
                    var customStyleItem = {};
                    var itemCSSItem = "item-name";
                    var customStyleCore = {};
                    var itemCSSItemCore = "item-name";
                    var itemOffersCategory = null;
                    var currencyCodeCf = null;
                    var strCurrencyCode = "";                

                    if (item.CustomFields != null) {
                        itemCF = item.CustomFields.find(cf => cf.Name == "Precio Core");
                        itemCFNP = item.CustomFields.find(cf => cf.Code == process.env.CF_PART_NUMBER);
                        currencyCodeCf = item.CustomFields.find(x => x.Name == "Currency");
                    }

                    if (currencyCodeCf != undefined || currencyCodeCf != null) {
                        if(currencyCodeCf.Values[0].length > 0){
                            strCurrencyCode = currencyCodeCf.Values[0];
                        }                        
                    }
                    
                    if (itemCF != null && itemCF.Values[0] != "") {
                        strPrecioCore = itemCF.Values[0];
                        if(strCurrencyCode == "USD"){
                            strPrecioCore = self.subToMXNCurrency(strPrecioCore);
                        }
                        classCoreHide = "";
                    }

                    if (itemCFNP != null && itemCFNP.Values[0] != "") {
                        strNumberPart = itemCFNP.Values[0];                   
                    }

                    if(strPrecioCore == ""){
                        classCoreHide = "hidden-price-core"
                    }

                    if (boolIsOverridenPrice) {
                        customStyleItem = { color: 'red' };
                        itemCSSItem = "item-name price-real";
                    }

                    if (boolIsOverridenCore) {
                        customStyleCore = { color: 'red' };
                        itemCSSItemCore = "item-name price-real";
                    }

                    if(strCurrencyCode == "USD"){
                        itemPrice = self.subToMXNCurrency(itemPrice);
                    }

                    if (item.Categories != null) {
                        itemOffersCategory = item.Categories.find(cat => cat.Name == "Ofertas");
                    }

                    var itemCorePrice = item.CustomFields.find(x => x.Code == process.env.CF_CORE_PRICE).Values[0];
                    var classPrecioCore = '';
                    if(itemCorePrice == 0) {
                        classPrecioCore = 'hide';
                    }

                    var classNumeroParte = '';
                    if(item.Name.includes(strPartCode)){
                        classNumeroParte = 'hide';
                    }

                    var cantidadExistencia = 0;
                    var colorCart = 'btnaddCart btn-group btn-cart';

                    if(item.StockQuantity == -1) {
                        cantidadExistencia = 100;
                    } else {
                        cantidadExistencia = item.StockQuantity;
                        if(cantidadExistencia == 0) {
                            colorCart += ' disabled';
                        }
                    }

                    return (
                        <div key={item.ID} className="col-md-2 col-sm-4  xs-mb-15" style={{marginBottom: '50px'}}>
                            <a href={self.itemUrl(item.Name, item.ID)} className="item-box-small item-related-carousel">
                                <div className="item-image" id="img-carousel">
                                    <img src={item.Media != null && item.Media.length > 0 ? item.Media[0].MediaUrl : self.defaultImage}
                                        alt={item.Name} title={item.Name} className="img-responsive" />
                                </div>
                            </a>
                            <div className="item-detail" style={{ marginBottom: '50px' }}>
                                <p className={"item-name " + classNumeroParte}>{strPartCode}</p>
                                <p className="item-name">{item.Name}</p>
                                <div>Existencias: <label id={"existenciasSearch" + strPartCode}>{cantidadExistencia}</label>
                                </div>
                                <div className={ colorCart }
                                    style={{padding: "5px", fontSize: "12px" }}
                                    id={"cartExistenciasSearch" + strPartCode}
                                    onClick={(e) => self.addItemToCart(item)}>
                                    Comprar
                                </div>
                                <div className="item-price" style={{paddingTop: "10px"}}>
                                    <div>
                                        <span id={"precioPublico" + strPartCode}><b>$ {self.subFormatMoney(itemPrice)} MXN</b></span><br/>
                                        <span id={"precioDescuento" + strPartCode}></span>
                                    </div>
                                    {self.renderOffer(item, classPrecioCore)}
                                    <label style={{ fontSize: '12px'}} className={classPrecioCore}>Precio CORE: $ {self.subFormatMoney(strPrecioCore)/*self.renderFormatMoney("MXN", itemCorePrice)*/} MXN</label>
                                </div>
                            </div>
                        </div>
                    );
                //}
            })}
        </div>
        )
    }

    getCellFooterImages(
        classCoreHide_I,
        itemOffersCategory_I
    ) {
        let returnFooter = (<div></div>);

        if (classCoreHide_I != undefined) {
            if (classCoreHide_I == "hide" || classCoreHide_I == "hidden-price-core") {
                    if(itemOffersCategory_I != undefined){
                        returnFooter = (
                            <div className="store-rating item-footer-images-container">
                                <div id="container-info-offerts-carousel">
                        		    <div id="icon-offers">
                            		    <div id="star-offers-carousel">&#10040;</div>
                            		    <div id="character-offers-carousel">%</div>
                        		    </div>
                        		    <div id = "offers-text-carousel">Oferta</div>
			                    </div>
                            </div>
                        );
                    }
            } else {
                if(itemOffersCategory_I != undefined){
                    returnFooter = (
                        <div className="store-rating item-footer-images-container" style={{display: 'flex'}}>
                           <div>
                    		    <div id="container-info-offerts-carousel">
                       			    <div id="icon-offers">
                        				<div id="star-offers-carousel">&#10040;</div>
                            			<div id="character-offers-carousel">%</div>
                        			</div>
                        			<div id = "offers-text-carousel">Oferta</div>
		
                        			<div id="icon-recon-carousel">
                            			<div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        			</div>
                        			<div id = "recon-text-carousel">Recon</div>
                    		    </div>
                		    </div>
                        </div>
                    );
                }else{
                    returnFooter = (
                        <div className="store-rating item-footer-images-container" style={{display: 'flex'}}>
                            <div id="container-info-offerts-carousel-nooffer">
                        		<div id="icon-recon-carousel">
                            		<div id="star-recon-carousel"><img alt="" style={{width:'14px'}} src="/assets/images/bepensa/recon-icon2-white.png" /></div>
                        		</div>
                        		<div id = "recon-text-carousel">Recon</div>
			                </div>
                        </div>
                    );
                }
                   
            }
        }
       
        return returnFooter;
    }

    render() {
        var classHide = (this.state.arrRelationalParts.length == 0) ? 'hide' : '';
        if(classHide == 'hide') {
                return (
                <React.Fragment>
                    <div className="bp-section-title ">
                        <h3>Potencia tu producto con estos complementos</h3>
                        <div className="divider"></div>
                        <div id="container-help">
                            <div className="icon-help-item" ></div>
                            <div id="container-help-text">
                                <p>Este artículo no tiene productos relacionados.</p>
                            </div>
                            <div style={{ width: '5%' }} ></div>
                        </div>
                    </div>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <div className={"bp-section-title " + classHide}>
                        <h3>Potencia tu producto con estos complementos</h3>
                        <div className="divider"></div>
                        <div>{this.renderCarousel()}</div>
                        <div className="divider"></div>

                        <div id="container-help"  >
                            <div className="icon-help-item" ></div>
                            <div id="container-help-text">
                                <p>Algunos de los resultados podrían no aplicar a su modelo de motor. En caso de duda por favor contacte a 
                                nuestros asesores.</p>
                            </div>
                            <div style={{ width: '5%' }} ></div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}

module.exports = ItemsPartesComponent;